__turbopack_context__.v({
  "backdrop": "mzjH8a_backdrop",
  "closeButton": "mzjH8a_closeButton",
  "gradientText": "mzjH8a_gradientText",
  "headingSection": "mzjH8a_headingSection",
  "mapPopover": "mzjH8a_mapPopover",
  "overallMatchContainer": "mzjH8a_overallMatchContainer",
  "popover": "mzjH8a_popover",
  "preferenceScoresContainer": "mzjH8a_preferenceScoresContainer",
  "preferenceScoresList": "mzjH8a_preferenceScoresList",
  "progressBarWrapper": "mzjH8a_progressBarWrapper",
  "scoreItem": "mzjH8a_scoreItem",
});
